import BottomSheetWebViewWrapper from '@di-shared/features/common/BottomSheetWebViewWrapper';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import {emitEventLog} from '@di-shared/features/analytics';

const BOTTOM_SHEET_FALLBACK_HEIGHT = 350;

function CapitalWithdrawBottomSheetPage(): JSX.Element {
  const {t} = useInferableTranslation();

  return (
    <BottomSheetWebViewWrapper bottomSheetFallbackHeight={BOTTOM_SHEET_FALLBACK_HEIGHT}>
      <div className="bottom_sheet">
        <div className="bottom_sheet_header">
          <h2 className="bottom_sheet_title">{t('T40156')}</h2>

          <button
            type="button"
            className="btn btn_ic"
            aria-label={t('T10017')}
            onClick={() => window.bottomSheetClose(false)}
          >
            <span
              className="ic ic_close_20px"
              aria-hidden="true"
            ></span>
          </button>
        </div>
        <div className="bottom_sheet_inner">
          <div className="bottom_sheet_contents">
            <strong className="bottom_sheet_title_sub">{t('T40157')}</strong>

            <div className="consent_agree">
              <div className="divider"></div>
              <div className="consent_agree_item">
                <p
                  className="consent_agree_desc"
                  style={{whiteSpace: 'pre-wrap'}}
                >
                  {t('T40158')}
                </p>
              </div>
            </div>
          </div>

          <div className="bottom_sheet_footer bottom_sheet_footer_complex">
            <button
              type="button"
              className="btn btn_large btn_outline"
              onClick={() => window.bottomSheetClose(false)}
            >
              {t('T20119')}
            </button>

            <button
              type="button"
              className="btn btn_large btn_filled"
              onClick={() => {
                emitEventLog({
                  event: 'di_vehicle_finance_terms',
                  data_action: 'complete_withdraw_consent',
                });
                window.bottomSheetClose(true);
              }}
            >
              {t('T40167')}
            </button>
          </div>
        </div>
      </div>
    </BottomSheetWebViewWrapper>
  );
}

export default CapitalWithdrawBottomSheetPage;
